module.exports = __webpack_public_path__ + "media/landing_work/home/images/support-4d839c6e68d045aafde0600e9f4730c0.png";